import * as React from 'react';
import { observer } from 'mobx-react';

import { useCabinetsStore, useRootStore } from 'stores/index';
import { useLocal } from 'shared/entities/common/hooks';
import { ComponentType } from 'shared/entities/components/Component';
import CabinetCreationStore from 'stores/cabinetCreationStore';
import { BaseModalProps } from 'shared/newEntities/components/modals';
import FormModal from 'shared/newComponents/modals/FormModal';
import CabinetCreationForm from 'shared/newContainers/CabinetCreationForm';
import { LoadingStage } from 'shared/entities/meta';

type Props = BaseModalProps;

const CabinetCreatingModal: React.FC<Props> = (props) => {
  const cabinetsStore = useCabinetsStore();
  const rootStore = useRootStore();

  const cabinetCreationStore = useLocal(
    () => new CabinetCreationStore({ rootStore, newUser: false })
  );

  React.useEffect(() => {
    cabinetCreationStore.subscribe();
    return () => {
      cabinetCreationStore.unsubscribeAll();
    };
  }, []);

  return (
    <FormModal
      title={(t) =>
        t('CabinetCreatingModal.title', {
          ns: 'newContainers'
        })
      }
      ok={{
        type: ComponentType.button,
        children: (t) =>
          t('CabinetCreatingModal.create', {
            ns: 'newContainers'
          }),
        onClick: cabinetCreationStore.createInitialData,
        isLoading: cabinetsStore.creatingStage === LoadingStage.LOADING,
        disabled: cabinetCreationStore.buttonDisabled
      }}
      {...props}
    >
      <CabinetCreationForm
        cabinetCreationStore={cabinetCreationStore}
        nameLabel={(t) =>
          t('CabinetCreatingModal.input.label', {
            ns: 'newContainers'
          })
        }
      />
    </FormModal>
  );
};

export default observer(CabinetCreatingModal);
